<template>
        <div class="container">
            <div class="topBack"></div>
            <div class="top">
                <div class="menu p-2">
                    <a class="submenu p-2 menuActive" href="index.html">砚溪书院</a>
                    <a class="submenu p-2 ml-2" href="news.html">砚溪动态</a>
                    <a class="submenu p-2 ml-2" href="student.html">学员风采</a>
					<!--<a class="submenu p-2 ml-2" href="teachers.html">教师风采</a>-->
                    <a class="submenu p-2 ml-2" href="about.html">联系方式</a>
                </div>
            </div>
            <div class="content">
				<div class="slideShowBorder p-1">
					<div id="slideShow" class="carousel slide" data-ride="carousel">
						<ol class="carousel-indicators">
							<li v-for="(slide,index) in slides" data-target="#slideShow" :data-slide-to="index" :class="index===0 ? 'active':''"></li>
						</ol>
						<div class="carousel-inner">
							<div class="carousel-item" v-for="(slide,index) in slides"  :class="index===0 ? 'active':''">
								<img :src="imgUrl + slide.imgUrl" class="slideShowImg d-block w-100">
							</div>
						</div>
						<a class="carousel-control-prev" href="#slideShow" role="button" data-slide="prev">
							<span class="carousel-control-prev-icon" aria-hidden="true"></span>
							<span class="sr-only">Previous</span>
						</a>
						<a class="carousel-control-next" href="#slideShow" role="button" data-slide="next">
							<span class="carousel-control-next-icon" aria-hidden="true"></span>
							<span class="sr-only">Next</span>
						</a>
					</div>
				</div>

                <div class="serve float-right">
                    <img class="float-right" src="../../assets/img/verse.png"/>
                </div>
                <div class="invisible">砚凝翰墨起鸿笔，溪引清风得静心</div>
                <div class="invisible">无锡砚溪书院是硬笔书法协会春星分会少儿硬笔培训基地，中国美术学院书画考级点。致力于为学员创造最专业正规的书法、绘画学习平台。</div>
            </div>
            <Cloud :isTopLeft="true" :isFooterRight="true"></Cloud>
            <Footer></Footer>
        </div>
</template>

<script>
    import Footer from '../../components/Footer'
    import Cloud from '../../components/Cloud'
	import {formatDate} from "@/assets/js/dateFormat";
    export default {
        name: "Index",
        components: {
            Footer,Cloud
        },
		data() {
			return {
				imgUrl: process.env.VUE_APP_IMGURL,
				slides: {}
			}
		},
		mounted() {
			this.getSlide();
		},
		methods: {
			getSlide() { // 获取全部的最新轮播图片
				this.$api.get('/slide/get').then(res => {
					this.slides = res;
				}).catch(err =>{});
			}
		}
    }
</script>

<style>
    html{
        height: 100%;
        font-family: 'ExtraLight';
        font-size: 16px;
    }
    body{
        height: 100%;
        background: url("../../assets/img/background.jpg") no-repeat bottom center fixed;
        -webkit-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
    }
    .container{
        height: 100%;
        border-left: 1px solid rgba(255,255,255,0.3);
        border-right: 1px solid rgba(255,255,255,0.3);
    }
    .topBack{
        z-index: 20;
        height: 242px;
        width: 100%;
        background: url("../../assets/img/topBack.png") no-repeat top right;
        position: fixed;
        top: 0;
        right: 0;
    }
    .top{
        z-index: 30;
        height: 110px;
        position: relative;
    }
    .menu{
        display: flex;
        width: 260px;
        height: 110px;
    }
    .menu>a{ color: #425c73; text-decoration: none !important; transition: all 0.3s linear; }
    .menu>a:hover{ color: #8e9e83; background-image: url("../../assets/img/menuHover.png"); }
    .submenu{
        line-height: 18px;
        height: 90px;
        width: 32px;
    }
    .menuActive{
        color: #ab3645 !important;
        display: block;
        background-image: url("../../assets/img/menuBack.gif") !important;
    }
    .serve{
        z-index: 8;
        max-width: 274px;
        max-height: 480px;
        position: relative;
    }
    @media (max-width: 400px) {.serve>img{ width: 55%; height: 55%; }}
    @media (min-width: 400px) and (max-width: 767px) {.serve>img{ width: 70%; height: 70%; }}
    @media (min-width: 768px) and (max-width: 991px) {.serve>img{ width: 70%; height: 70%; }}
    @media (min-width: 992px) and (max-width: 1199px) {.serve>img{ width: 80%; height: 80%; }}
    @media (min-width: 1200px) {.serve>img{ width: 90%; height: 90%; }}

	.slideShowBorder{
		border: solid 0 #e9ede6;
	}
	#slideShow{ border: solid 0 #d9ded5; z-index: 30; }
	.slideShowImg{ opacity: 0.8; }
	@media (max-width: 325px) { #slideShow{ height: 135px;max-height: 135px; } .slideShowImg{ height: 135px; max-height: 135px; } }
	@media (min-width: 326px) and (max-width: 415px) { #slideShow{ height: 200px;max-height: 200px; } .slideShowImg{ height: 200px; max-height: 200px; } }
	@media (min-width: 416px) and (max-width: 767px) { #slideShow{ height: 280px;max-height: 280px; } .slideShowImg{ height: 280px; max-height: 280px; } }
	@media (min-width: 768px) and (max-width: 991px) { #slideShow{ height: 320px;max-height: 320px; } .slideShowImg{ height: 320px; max-height: 320px; } }
	@media (min-width: 992px) and (max-width: 1199px) { #slideShow{ height: 350px;max-height: 350px; } .slideShowImg{ height: 350px; max-height: 350px; } }
	@media (min-width: 1200px) { #slideShow{ height: 350px;max-height: 350px; } .slideShowImg{ height: 350px; max-height: 350px; } }
</style>
